export default __webpack_public_path__ + "img/rank2tabs-28d8fede.png";